import { useMutation, useQueryClient } from '@tanstack/react-query';

import { kubesoloTestCreate } from '@api/sdk.gen';
import { KubesoloCreateTestPayload } from '@api/types.gen';

import { withError } from '@/react-tools/react-query';

import { queryKeys } from './queryKeys';

export function useStartConnectionTestMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: KubesoloCreateTestPayload) => {
      const { data } = await kubesoloTestCreate({ body });
      return data;
    },
    onSuccess: (test) => queryClient.setQueryData(queryKeys.active(), test),
    ...withError('Unable to start the connection test'),
  });
}
